import { render, staticRenderFns } from "./search.vue?vue&type=template&id=650691ea&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650691ea')) {
      api.createRecord('650691ea', component.options)
    } else {
      api.reload('650691ea', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=650691ea&", function () {
      api.rerender('650691ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/partials/search.vue"
export default component.exports